import { action, makeObservable } from 'mobx';
import { BaseListViewStore } from 'core/stores';
import { historyLogSource } from 'common/constants';
import { ReceivingStore } from 'modules/receiving/stores';

class ReceivingHistoryLogViewStore extends BaseListViewStore {
	constructor(rootStore) {
		super(rootStore, {
			listStore: new ReceivingStore(rootStore),
			findFunction: 'findReceivingHistoryLog',
			queryParams: { embed: ['user'] },
		});
		makeObservable(this);
		this.queryUtility.initialize(this.findReceivingHistoryLog);
	}

	@action.bound
	findReceivingHistoryLog = async () => {
		this.suspend();
		let filter = this.queryUtility.filter;
		filter.source = String(historyLogSource.receiving);
		if (this.rootStore.routerStore.routerState.params.id) {
			filter.itemId = String(this.rootStore.routerStore.routerState.params.id);
		}
		if (filter.orderBy === null && filter.orderDirection === null) {
			filter.orderBy = 'dateCreated';
			filter.orderDirection = 'desc';
		}
		await this.listStore.findReceivingHistoryLog(filter);
		if (this.listStore.response.item.length === 0 && this.listStore.response.page !== 1) {
			await this.queryUtility.changePage(1);
		}
		this.queryUtility.handleResponse(this.listStore.response);
		// When history log data is rendered, go back to previous route (reset to initial route when modal was opened).
		this.rootStore.historyAdapter.goBack();
		this.resume();
	};
}

export default ReceivingHistoryLogViewStore;



// WEBPACK FOOTER //
// ./src/modules/receiving/stores/ReceivingHistoryLogViewStore.js